import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the Item class to inform that the item should display a toggle in the UI
 *   for controlling visibility in view mode
 * @param {LayoutItem} Item The item to enhance
 */
export const withHideInViewMode: PresetHOC<{
    showHideInViewMode?: boolean;
}> = (Item) => {
    Item.showHideInViewMode = true;

    return Item;
};
